<template>
<div id="app">
  <router-view/>
  <Modal v-model="showLogoutModal" title="警告" :closable="false" :mask-closable="false" :styles="{top: '100px'}">
    <div><p>您已28分钟无操作，2分钟后将自动注销</p></div>
    <div slot="footer">
      <Button type="primary" @click="zhuxiao">立即注销</Button>
      <Button type="success" @click="resetTimer">保持登录</Button>
    </div>
  </Modal>
</div>
</template>


<script>
    import {
            mapGetters
    } from "vuex";
export default {
  name: "App",
    computed: {
        ...mapGetters([
            "user"
        ]),
      // 计算剩余时间（分钟:秒）
      formattedTime() {
        const remaining = this.inactivityTime - (Date.now() - this.lastActivity);
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      },
    },
    data() {
      return {
        lastActivity: Date.now(),
        inactivityTime: 30 * 60 * 1000,
        // 警告时间（在注销前2分钟提示）
        warningTime: 2 * 60 * 1000,
        timer: null,
        warningTimer: null,
        logoutTimer: null,
        isActive: true,
        showWarning: false,
        warningMessage: '',
        showLogoutModal: false,
        countdown: 120, // 2分钟倒计时（秒）
        eventLog: [],
        titleTimer: null
      }
    },

    created() {
        const _this = this
        if(!localStorage.getItem('is_one')) {
          _this.$router.push({
            name: "login"
          });
        }
      console.log('dms-app-token', localStorage.getItem('dms-app-token'));
      if(!localStorage.getItem('dms-app-token')) {

        _this.$router.push({
          name: "login"
        });
      }
        document.addEventListener("visibilitychange", function () {
            console.log('this.user', _this.$store.state.user);

            if(_this.$store.state.user != null && _this.$store.state.user.username != localStorage.getItem('user_name') && this.$store.state.user.is_one && !localStorage.getItem('dms-app-token')) {
                _this.$router.push('/index/MyTask', { catch: false });
                location.reload();
            }
        });
      this.setupEventListeners();
      this.startTimer();

    },
    methods: {
      // 设置事件监听
      setupEventListeners() {
        console.log('添加监听器')
        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
        events.forEach(event => {
          window.addEventListener(event, this.resetTimer);
        });
      },
      removeEventListeners() {
        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
        events.forEach(event => {
          window.removeEventListener(event, this.resetTimer);
        });
      },
      // 重置计时器
      resetTimer() {
        document.title = '经销商管理系统';
        console.log('检测到用户活动，重置计时器');
        this.lastActivity = Date.now();
        this.isActive = true;
        this.showWarning = false;
        this.showLogoutModal = false;

        // 清除现有计时器
        clearTimeout(this.timer);
        clearTimeout(this.warningTimer);
        clearTimeout(this.logoutTimer);
        clearInterval(this.countdownInterval);
        clearInterval(this.titleTimer);

        // 重新启动计时器
        this.startTimer();
      },
      // 启动计时器
      startTimer() {
        // 主计时器 - 在30分钟无活动后注销
        console.log("开始监控");
        this.timer = setTimeout(() => {
          console.log('30分钟无活动，开始注销倒计时');
          this.startLogoutCountdown();
        }, this.inactivityTime - this.warningTime);

        // 警告计时器 - 在28分钟时显示警告
        this.warningTimer = setTimeout(() => {
          this.showWarning = true;
          // this.warningMessage = '您已28分钟无操作，2分钟后将自动注销';
          this.showLogoutModal = true;
          this.removeEventListeners();
          clearInterval(this.titleTimer);

          this.titleTimer = setInterval(() => {
            // 在原始标题和状态间切换
            document.title = document.title.includes('❗')
              ? `经销商管理系统`
              : `❗ 1 条新消息`;
          }, 1000);
        }, this.inactivityTime - this.warningTime);
      },
      // 开始注销倒计时
      startLogoutCountdown() {

        this.isActive = false;
        // 开始倒计时
        this.countdown = 120;
        this.countdownInterval = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.countdownInterval);
          }
        }, 1000);

        // 设置最终注销计时器
        this.logoutTimer = setTimeout(() => {
          this.showLogoutModal = false;
          this.zhuxiao();
        }, this.warningTime);
      },
      zhuxiao() {
        document.title = '经销商管理系统';
        // localStorage.clear();
        this.$router.push({
          name: "page600"
        });
        // 重置状态
        this.resetTimer();
      },
      // 注销用户
      logout() {
        this.$router.push({
          name: "login"
        });
      },
    },
  beforeDestroy() {
    // 清除所有计时器和事件监听
    clearTimeout(this.timer);
    clearTimeout(this.warningTimer);
    clearTimeout(this.logoutTimer);
    clearInterval(this.countdownInterval);
    clearInterval(this.titleTimer);
    // localStorage.clear();
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.removeEventListener(event, this.resetTimer);
    });
  }
};
</script>

<style>
#app {
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

.ivu-form-item-label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 12px;
    color: #515a6e;
    line-height: 1;
    padding: 10px 12px 10px 0;
    box-sizing: border-box;
}

.ivu-form-item-content {
    position: relative;
    line-height: 32px;
    font-size: 12px;
}

textarea {
  resize: none;
}

.cursorPointer {
  cursor: pointer;
}

.dms-working {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.dms-pass {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.dms-reject {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.dms-process {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.dms-pass .icon {
  background: url(assets/images/icon-DMSstate-green.png);
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-size: 100% 100%;
}

.dms-working .icon {
  background: url(assets/images/icon-DMSstate-yellow.png);
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-size: 100% 100%;
}

.dms-reject .icon {
  background: url(assets/images/icon-DMSstate-red.png);
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-size: 100% 100%;
}

.dms-process .icon {
  background: url(assets/images/icon-DMSState-gray.png);
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-size: 100% 100%;
}

 .ivu-table th {
  background: rgba(163, 183, 216, 1);
}

.ivu-table-header .ivu-table-cell {
  font-size: 13px;
  font-weight: 900;
}

.ivu-btn {
  width: auto !important;
}

.contentTitle {
  font-size: 20px;
  font-weight: 700;
  color: #4060ad;
  margin-left: 10px;
}

.contentTitle_small {
  font-size: 16px;
  font-weight: 700;
  color: #4060ad;
  margin-left: 10px;
}

.estimation_title {
  font-size: 14px;
  font-weight: 700;
  margin-left: 40px;
}

.ivu-btn-next {
  width: 300px;
}

.ivu-workflow-btn {
  width: 120;
}

.ivu-modal-footer {
  border-top: 0px;
}

.ivu-modal-header {
  border-bottom: 0px;
  padding: 14px 0px 0px 16px;
}

.ivu-modal-body {
  padding: 8px 8px 0px 8px;
}

.history {
  font-size: 13px;
  font-weight: 700;
}



.ubtn_add {
  font-size: 12px;
  cursor: pointer;
  margin-left: 60px;
}

.ubtn_add:hover {
  color: #2d8cf0;
}
.ubtn {
  font-size: 12px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 20px;
}

.ubtn:hover {
  color: #2d8cf0;
}
.ubtn_delete {
  font-size: 12px;
  cursor: pointer;
}

.ubtn_delete:hover {
  color: #2d8cf0;
}

.workflow_approve {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 30px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #19be6b;
}

.workflow_approve2 {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 210px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #19be6b;
}

.workflow_resubmit {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 90px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #2d8cf0;
}

.workflow_refuse {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 30px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #be194b;
}

.workflow_return {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 90px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #2d8cf0;
}

.workflow_revoke {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 131px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #2d8cf0;
}


.workflow_back {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 80px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #F93E58;
}

.workflow_submit {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 30px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #2d8cf0;
}

.workflow_save {
    width: 60px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    position: fixed;
    bottom: 90px;
    right: 20px;
    transition: opacity 0.2s ease-in-out;
    background: #19be6b;
}

.workflow_returnGreen {
  width: 60px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 150px;
  right: 20px;
  transition: opacity 0.2s ease-in-out;
  background: #F5CA85;
}

.custom_label {
  text-align: center;
  vertical-align: middle;
  float: right;
  font-size: 12px;
  color: #515a6e;
  line-height: 1;
  padding: 10px 12px 10px 0;
  box-sizing: border-box;
  width: 100%;
  font-weight: 700;
}

.spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.spin-message {
  font-size: 20px;
  font-family: "Courier New", Courier, monospace;
  font-weight: 700px;
}

td.ivu-table-expanded-cell {
  padding: 10px 0px 10px 20px
}

.ivu-collapse {
  background-color: #f7f7f7;
}

/* .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
  color: white;
} */

.table_btn {
  cursor: pointer;
  color: #2d8cf0;
}

.column_cursor {
  cursor: pointer;
}

.columnField {
  font-size: 12px;
  font-weight: 700
}
.ivu-table-overflowX{
  overflow-x:hidden;
}



/* .ivu-form-item-required .ivu-form-item-label:before {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: blue
} */
/* .aa{
  background: red !important;
} */

/* .ivu-form-item-label {
  font-size: 12px;
  font-weight: 900;
} */


/* .ivu-form .ivu-form-item-label{
  font-weight: 700;
  color: #4060ad;
  font-size: 12px;
} */

.ivu-input[disabled],
fieldset[disabled] .ivu-input {
    color: black!important;
}

.ivu-select-disabled .ivu-select-selection {
    color: black!important;
}

.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #2d8cf0!important;
    background-color: #2d8cf0!important;
}

.ivu-input-number-disabled .ivu-input-number-input {
    color: black!important;
}

.ivu-checkbox-disabled+span {
    color: black!important;
}

.ivu-switch-disabled .ivu-switch-inner {
    color: black!important;
}

input[disabled],input:disabled,input.disabled{

-webkit-text-fill-color:#333!important;

/*-webkit-opacity:1;*/

/*opacity: 0;*/

}

.ivu-radio-checked{
color: #333!important;
}
.ivu-radio-disabled .ivu-radio-inner:after {
background-color: #333!important;
}
.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {
animation-name: none!important;
border-color: #333!important;
}


</style>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/App.vue